import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import axios from '../axios';
import config from "../config";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../shadcn/ui/dialog';
import { Button } from '../shadcn/ui/button';
import { TrashIcon } from '@heroicons/react/24/outline';
import CustomFileInput from './CustomFileInput';
import { useToast } from '../shadcn/ui/use-toast';
import DeleteConfirmationDialog from './DeleteConfirmationDialog';
import MediaViewDialog from '../Components/Dialog/MediaViewDialog';


const MediaDialog = ({ isOpenMediaDialog, onCloseMediaDialog, onSelectMedia, maxSelection }) => {
    const { toast } = useToast();

    const [selectedMedia, setSelectedMedia] = useState([]);
    const [mediaFiles, setMediaFiles] = useState([]);
    const [isLoadingMedia, setIsLoadingMedia] = useState(true);
    const [error, setError] = useState(null);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [mediaToDelete, setMediaToDelete] = useState(null);
    const [isFileInputActive, setIsFileInputActive] = useState(false); // Track if the file input is active

    const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
    const [viewedMedia, setViewedMedia] = useState(null);

    const handleViewMedia = (mediaItem) => {
        setViewedMedia(mediaItem);
        setIsViewDialogOpen(true);
    };

    const handleCloseViewDialog = () => {
        setIsViewDialogOpen(false);
        setViewedMedia(null);
    };

    useEffect(() => {
        if (isOpenMediaDialog) {
            fetchMedia();
        }
    }, [isOpenMediaDialog]);

    const fetchMedia = async () => {
        setIsLoadingMedia(true);
        try {
            const response = await axios.get('/api/media'); // Replace with your actual API endpoint
            setMediaFiles(response.data);
        } catch (err) {
            setError('Failed to load media.');
            console.error('Error fetching media:', err);
        } finally {
            setIsLoadingMedia(false);
        }
    };

    // const toggleMediaSelection = (identifier) => {
    //     console.log(identifier);
    //     setSelectedMedia((prevSelected) => {
    //         const isAlreadySelected = prevSelected.includes(identifier);
    //         if (isAlreadySelected) {
    //             console.log(prevSelected);
    //             return prevSelected.filter((item) => item.id !== identifier.id);
    //         } else {
    //             if (maxSelection && prevSelected.length >= maxSelection) {
    //                 return prevSelected;
    //             }
    //             return [...prevSelected, identifier];
    //         }
    //     });
    // };

    const toggleMediaSelection = (identifier) => {
        setSelectedMedia((prevSelected) => {
            const isAlreadySelected = prevSelected.some(item => item.id === identifier.id);

            if (isAlreadySelected) {
                // If the clicked item is already selected, unselect it
                return [];
            } else {
                // Otherwise, select the new item and unselect the previous one
                return [identifier];
            }
        });
    };

    const handleSelect = () => {
        onSelectMedia(selectedMedia);
        setSelectedMedia([]);
        onCloseMediaDialog(); // Close the dialog after selecting media
    };

    const handleOpenDeleteDialog = (media) => {
        setMediaToDelete(media);
        setIsDeleteDialogOpen(true);
    };

    const handleCloseDeleteDialog = () => {
        setIsDeleteDialogOpen(false);
        setMediaToDelete(null);
    };

    const handleDelete = async () => {
        if (!mediaToDelete) return;

        try {
            await axios.delete(`/api/media/${mediaToDelete.id}`);
            setMediaFiles(prevFiles => prevFiles.filter(file => file.id !== mediaToDelete.id));
            toast({
                title: 'Deleted',
                description: 'The media file has been deleted.',
                variant: 'success',
            });
        } catch (error) {
            console.error('Error deleting media:', error);
            toast({
                title: 'Error',
                description: 'Failed to delete the media file.',
                variant: 'error',
            });
        } finally {
            handleCloseDeleteDialog();
        }
    };

    const handleClose = () => {
        onCloseMediaDialog();
        setIsFileInputActive(false);
    };

    const handleUploadSuccess = (newMedia) => {
        setMediaFiles(prevFiles => [...prevFiles, ...newMedia]);
        toast({
            title: 'Files uploaded successfully!',
            description: '',
            variant: 'success',
            duration: 3000,
        });
        setIsFileInputActive(false); // Show media content again after upload
    };

    const handleFilesSelected = () => {
        setIsFileInputActive(true); // Hide media content when files are selected
    };

    const handleFilesCancel = () => {
        setIsFileInputActive(false);
    };

    return (
        <Dialog open={isOpenMediaDialog} onOpenChange={onCloseMediaDialog} className="fixed inset-0 flex items-center justify-center z-50">
            <DialogContent className="media-dialog-content w-full max-w-6xl mx-auto">
                <DialogHeader>
                    <DialogTitle>Βιβλιοθήκη Πολυμέσων</DialogTitle>
                </DialogHeader>
                <div className="media-dialog-body">
                    {/* {isFileInputActive ? ( */}
                    <div className="media-upload-section mb-4">
                        <CustomFileInput
                            // onClick={() => setIsFileInputActive(true)}
                            onUploadSuccess={handleUploadSuccess}
                            onFilesSelected={handleFilesSelected}
                            onCancel={handleFilesCancel}
                        />
                    </div>
                    {isLoadingMedia ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <p>{error}</p>
                    ) : !isFileInputActive ? (
                        <div className='overflow-scroll max-h-80'>
                            {/* <div className="grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-3 grid-cols-2 gap-4 mt-10">
                                {mediaFiles.map((item) => (
                                    <div key={item.id} className={`flex items-center media-file ${selectedMedia.includes(item) ? 'selected' : ''}`}>
                                        <div className="custom-checkbox-wrapper">
                                            <input
                                                type="checkbox"
                                                id={`media-${item.id}`}
                                                checked={selectedMedia.includes(item)}
                                                onChange={() => toggleMediaSelection(item)}
                                                className="custom-checkbox mr-2"
                                            />
                                        </div>

                                        <label className="hover:cursor-pointer" htmlFor={`media-${item.id}`}>
                                            <img src={item.file_path} alt="media" className="w-32 h-32 object-cover" />
                                        </label>
                                        <Button variant="outline" size="sm" className="delete-btn-wrapper" onClick={() => handleOpenDeleteDialog(item)}>
                                            <TrashIcon className="h-5 w-5 text-red-500" />
                                        </Button>
                                    </div>
                                ))}
                            </div> */}

                            <div className="grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-3 grid-cols-2 gap-4 mt-10">
                                {mediaFiles.map((item) => (
                                    <div
                                        key={item.id}
                                        className={`flex items-center media-file ${selectedMedia.includes(item) ? 'selected' : ''}`}
                                    >
                                        <div className="custom-checkbox-wrapper">
                                            <input
                                                type="checkbox"
                                                id={`media-${item.id}`}
                                                checked={selectedMedia.includes(item)}
                                                onChange={() => toggleMediaSelection(item)} // Only toggle when checkbox is clicked
                                                className="custom-checkbox mr-2"
                                            />
                                        </div>

                                        <div className="media-label-wrapper" onClick={() => handleViewMedia(item)}>
                                            <label className="hover:cursor-pointer">
                                                <img
                                                    src={config.apiUrl+item.file_path}
                                                    alt="media"
                                                    className="w-32 h-32 object-cover pointer-events-none" // Prevent label/image from being clickable
                                                />
                                            </label>
                                        </div>

                                        <Button
                                            variant="outline"
                                            size="sm"
                                            className="delete-btn-wrapper"
                                            onClick={() => handleOpenDeleteDialog(item)}
                                        >
                                            <TrashIcon className="h-5 w-5 text-red-500" />
                                        </Button>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-4 flex justify-end">
                                <Button onClick={handleSelect} disabled={selectedMedia.length === 0}>
                                    Επιλογή
                                </Button>
                            </div>
                        </div>
                    ) : null}
                </div>
            </DialogContent>

            <DeleteConfirmationDialog
                isOpen={isDeleteDialogOpen}
                onClose={handleCloseDeleteDialog}
                onDelete={handleDelete}
                confirmationTitle={'Delete media'}
                confirmationMessage={`Are you sure you want to delete the media file with ID "${mediaToDelete?.id}"?`}
            />

            <MediaViewDialog
                isOpen={isViewDialogOpen}
                onClose={handleCloseViewDialog}
                mediaItem={viewedMedia}
            />
        </Dialog>
    );
};

export default MediaDialog;
